import { createContext } from 'react';

import { ClientContextValue, OverrideClientType } from '../typings.js';

export const QueryClientContext = createContext<ClientContextValue<OverrideClientType> | null>(
  null
);

export default QueryClientContext;
